export default "__VITE_ASSET__86ce1e11__"